import { computed, signal } from '@angular/core';

import { DIDO_DOCUMENTEN_CONTROL_CONSTANTS } from '../../dido-documenten-control.constants';

/** Represents a request to upload a physical file */
export class DidoFileUploadRequest {
    /** Physical file in browser */
    file: File;
    /** Status */
    readonly status = signal('new');
    /** Message linked to status */
    readonly statusMessage = signal<string>('');
    /** The upload progress */
    readonly progress = signal(0);
    /** User friendly display of the size of the file */
    sizeDisplay: string;
    /** Temporary file */
    tempFile: string;
    /** File extension */
    readonly extension = signal<string>('');
    readonly pending = computed(() => this.progress() !== 100 && this.progress() > 0);
    readonly iconClass = computed(() => {
        const mappedExtension = DIDO_DOCUMENTEN_CONTROL_CONSTANTS.ALLOWED_EXTENSION_MAPPINGS.find((mapping) => mapping.extension == this.extension());
        return mappedExtension ? mappedExtension.fontIcon : 'fa-file';
    });
}
